import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import type { ResultRow } from "./useCompetitorLinkRemovalDetail";
import { CompetitorLinkRemovalLabels } from "./CompetitorLinkRemovalLabels";
import { removalStatusColor } from "./RemovalStatusColor";
import type { JSX } from "react";

interface RunResultsTableProps {
  rows: ResultRow[];
}

export function RunResultsTable(props: RunResultsTableProps) {
  let runResultsTable: JSX.Element;
  if (props.rows.length === 0) {
    runResultsTable = (
      <Box mb={3}>
        <Typography variant="h6" mb={1}>Результаты</Typography>
        <Typography color="text.secondary">Пока ничего не найдено.</Typography>
      </Box>
    );
  } else {
    runResultsTable = (
    <Box mb={3}>
      <Typography variant="h6" mb={1}>Результаты</Typography>
      <TableContainer component={Paper} variant="outlined" sx={{ overflowX: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Донор</TableCell>
              <TableCell>URL поста</TableCell>
              <TableCell>Найденный URL конкурента</TableCell>
              <TableCell>Анкорный текст</TableCell>
              <TableCell>Статус удаления</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.siteUrl}</TableCell>
                <TableCell>
                  <Link href={row.postUrl} target="_blank" rel="noopener noreferrer">
                    {row.postTitle.length > 0 ? row.postTitle : row.postUrl}
                  </Link>
                </TableCell>
                <TableCell>
                  {row.matchedLinks.map((link, index) => (
                    <Typography key={`${row.id}-c-${index}`} variant="body2">
                      {link.competitorUrl}
                    </Typography>
                  ))}
                </TableCell>
                <TableCell>
                  {row.matchedLinks.map((link, index) => (
                    <Typography key={`${row.id}-a-${index}`} variant="body2">
                      {link.anchorText}
                    </Typography>
                  ))}
                </TableCell>
                <TableCell>
                  <Chip size="small" color={removalStatusColor(row.removalStatus)} label={CompetitorLinkRemovalLabels.postRemovalStatus(row.removalStatus)} />
                  {row.errorDescription !== null && (
                    <Typography variant="caption" color="error" display="block">
                      {row.errorDescription}
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
  }
  return runResultsTable;
}
